import { lazy, Suspense } from "react";
/// Components
import Index from "./jsx/router/index";
import { connect } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { selectIsAuthenticated } from "./store/authSlice";

/// Style
import "rsuite/dist/rsuite-no-reset.min.css";
import "./tailwind.css";
import "./assets/css/style.css";

const SignUp = lazy(() => import("./jsx/pages/authentication/Registration"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/authentication/Login")), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  let routeblog = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/:locale/login" element={<Login />} />
      <Route path="/page-register" element={<SignUp />} />
      <Route path="/:locale/page-register" element={<SignUp />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
  if (props.isAuthenticated) {
    const { pathname } = props.router.location;
    if (pathname === "/login" || pathname === "/page-register") {
      return <Navigate to="/dashboard" replace />;
    }
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routeblog}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
});

export default withRouter(connect(mapStateToProps)(App));
